module.exports = __webpack_public_path__ + "static/media/Global 4000 City Download 2025.8056606d.pdf";